import { render, staticRenderFns } from "./ProjectDetailsChild.vue?vue&type=template&id=aabd7a58&scoped=true&"
import script from "./ProjectDetailsChild.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsChild.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsChild.vue?vue&type=style&index=0&id=aabd7a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabd7a58",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ProjectDetailsChild.vue
// module id = 294
// module chunks = 0